import type { Environment } from 'config/environment'

import { init } from 'modules/core/lib/metrics'

export default (environment: Environment) => {
  init(environment)
}
